import React, { useState, useEffect } from 'react';
import { Api, useTranslation } from 'lb-store';
import { UseUser } from 'lb-store/src/hooks';
import { Badge, Stack, Accordion } from 'react-bootstrap';

import classes from './Notifications.module.scss';
import _ from 'lodash';
import { Icon } from 'lb-components';
import Form from 'react-bootstrap/Form';
import { EnvelopeOpen, Trash } from '../../../../assets/icons';

const Notifications = () => {
  const {t} = useTranslation()
  const [checked,setChecked] = useState([])
  const [notifications, setNotifications] = useState([]);
  const { User } = UseUser();
  useEffect(() => {
    getData()
  }, []);
  const getData = () =>{
    Api.User.Notifications.list({}).then((res) => {
      if (res.data?.status === 200 && res.data?.success) {
        setNotifications(res.data?.data);
      }
    });
  }
  return (
    <div className={classes.container}>
      <header>

        <Form.Check
          style={{marginLeft:"12px"}}
          checked={_.isEqual(checked.sort(),notifications.map(v=>v.id).sort())}
          onChange={e=>{
            if(e.target.checked){
              setChecked([...notifications.map(v=>v.id)])
            }else{
              setChecked([])
            }
          }}
          type={"checkbox"}
          id={`notification`}
          label={t("მონიშნე ყველა")}
        />
        {User.notifications > 0 && (
          <span>
            <Badge bg={'danger'} style={{ marginRight: '0.8rem' }}>
              {User.notifications}
            </Badge>
            {t("შემოსული")}
          </span>
        )}
        <div style={{flex:1}}></div>
        {
          checked.length>0 && (
            <div style={{
              marginRight:"20px"
            }} >
              <Icon Icon={EnvelopeOpen} style={{
                width:"2rem",
                height:"2rem",
                color:`var(--bs-white)`,
                cursor:'pointer'
              }}
                onClick={()=>{
                  Api.User.Notifications.readAll({id:checked})
                    .then(()=>{
                      if(window.updateUserNotifications){
                        window.updateUserNotifications()
                      }
                      setChecked([])
                      getData()
                    })
                }}
              />
            </div>
          )
        }
        {
          checked.length>0 && (
            <div style={{
              marginRight:"32px"
            }}>
              <Icon Icon={Trash} style={{
                width:"2rem",
                height:"2rem",
                cursor:'pointer'
              }}
                    onClick={()=>{
                      Api.User.Notifications.deleteAll({id:checked})
                        .then(()=>{
                          if(window.updateUserNotifications){
                            window.updateUserNotifications()
                          }
                          setChecked([])
                          getData()
                        })
                    }}
              />
            </div>
          )
        }

      </header>
      <Accordion className={classes.list} flush>
        {notifications.length === 0 ? (
          <h1>{t("თქვენ არ გაქვთ შეტყობინება")}</h1>
        ) : (
          notifications.map((item) => (
            <Accordion.Item
              key={item.id}
              eventKey={item.id}
              className={classes.item}
            >
              <Accordion.Header
                className={classes.header}
                onClick={(e) => {
                  const index = _.findIndex(
                    notifications,
                    (i) => i.id === item.id
                  );
                  if (index >= 0 && !notifications[index].body) {

                    Api.User.Notifications.read({id:item.id}).then(()=>{
                      Api.User.Notifications.get({
                        id: item.id,
                      }).then((res) => {
                        if (res.data?.status === 200 && res.data?.success) {
                          const updatedNotifications = [...notifications];
                          updatedNotifications[index] = {
                            ...notifications[index],
                            body: res.data.data.ka.body,
                          };
                          setNotifications(updatedNotifications);
                        }
                      });
                    })

                  }
                }}
              >
                <Form.Check
                  checked={checked.indexOf(item.id)>-1}
                  type={"checkbox"}

                  id={`default-checkbox nofitication-checkbox`}
                  label={``}
                  onClick={e=>e.stopPropagation()}
                  onChange={e=>{
                    if(e.target.checked){
                      setChecked([...checked,item.id])
                    }else {
                      setChecked(checked.filter(v => v !== item.id))
                    }
                  }}
                />
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontWeight: item.read ? 'normal' : 'bold',
                  }}
                >
                  <span>{item.subject}</span>
                  <span style={{ fontSize: '1.35rem' }}>
                    {item.create_date}
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body
                className={classes.body}
                dangerouslySetInnerHTML={{ __html: item?.body }}
              />
            </Accordion.Item>
          ))
        )}
      </Accordion>
    </div>
  );
};

export default Notifications;
